import type { EditorBaseHooks } from '#packages/editorCore';
import { LoadingErrorType } from '../errorScreen/types';
import type { LoadI18n } from '../types';

export function registerErrorScreen({
  editorBaseHooks,
  loadI18n,
}: {
  editorBaseHooks: EditorBaseHooks;
  loadI18n: LoadI18n;
}) {
  editorBaseHooks.editorBuildAndRender.promise.catch(async (e) => {
    try {
      const { loadErrorScreen } = await import('../errorScreen');

      await loadErrorScreen({
        error: {
          type: LoadingErrorType.Unknown,
          name: e.name,
        },
        loadI18n,
      });
    } catch (error) {
      console.error('Failed to initialize error screen:', error);
    }
  });
}
